export default __webpack_public_path__ + "pending-active.svg";